export default __webpack_public_path__ + "static/media/misc-books2-480w.39af56ba.avif";